import React, { useRef } from 'react';
import { Box, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

const VerificationCodeInput = ({ setOtpComplete, onOtpChange }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [digits, setDigits] = React.useState(Array(6).fill(''));
    const inputRefs = useRef([]);

    const update = (newDigits) => {
        setDigits(newDigits);
        const otpValue = newDigits.join('');
        onOtpChange(otpValue);
        setOtpComplete(newDigits.every((d) => d !== ''));
    };

    const handleChange = (index, value) => {
        const digit = value.replace(/\D/g, '').slice(-1);
        const newDigits = [...digits];
        newDigits[index] = digit;
        update(newDigits);
        if (digit && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !digits[index] && index > 0) {
            const newDigits = [...digits];
            newDigits[index - 1] = '';
            update(newDigits);
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        const newDigits = Array(6).fill('');
        pasted.split('').forEach((char, i) => { newDigits[i] = char; });
        update(newDigits);
        inputRefs.current[Math.min(pasted.length, 5)]?.focus();
    };

    const inputSx = {
        flex: 1,
        minWidth: 0,
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            boxShadow: '0px 1px 2px 0px rgba(16,24,40,0.05)',
            backgroundColor: '#fff',
            '& fieldset': { borderColor: '#ff669b' },
            '&:hover fieldset': { borderColor: '#ff669b' },
            '&.Mui-focused fieldset': { borderColor: '#ff669b', borderWidth: 2 },
        },
        '& input': {
            textAlign: 'center',
            color: '#616063',
            fontSize: '16px',
            padding: isMobile ? '8px 4px' : '10px 14px',
            letterSpacing: '-0.32px',
        },
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? '6px' : '12px', width: '100%' }}>
            {digits.map((digit, index) => (
                <React.Fragment key={index}>
                    <TextField
                        inputRef={(el) => { inputRefs.current[index] = el; }}
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={handlePaste}
                        inputProps={{ maxLength: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
                        sx={inputSx}
                    />
                    {!isMobile && index < 5 && (
                        <Typography
                            component="span"
                            sx={{ color: '#e5e5e5', fontSize: '30px', lineHeight: '38px', flexShrink: 0, userSelect: 'none' }}
                        >
                            -
                        </Typography>
                    )}
                </React.Fragment>
            ))}
        </Box>
    );
};

export default VerificationCodeInput;
